import { useCallback, useMemo, useState } from "react";
import CButton from "../../common/CButton";
import CFolloUpOrders from "../../common/CFolloUpOrders";

import CommonMessage from "../../common/CommonMessage";
import { Button, Modal } from "react-bootstrap";
import CommonDropdown from "../../common/CommonDropdown";
import { addFollowUpRemarks } from "../../services/followUpService";

const FollowUpReOrders = () => {
    const [loadingRow, setLoadingRow] = useState(null);
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [errors, setErrors] = useState({});
    const [updateStatus, setUpdateStatus] = useState("");
    const [formData, setFormData] = useState({
        remarks: "",
        followUpDate: "",
        //status: "",
    });
    const RemarksStatus = [
        { id: 1, name: "Interested" },
        { id: 2, name: "Not Interested" },
        { id: 3, name: "Closed" },
    ]
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear field error while typing
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    // Open popup
    const openRemarksPopup = (rowData) => {
        setSelectedRow(rowData);
        setShowModal(true);

        setUpdateStatus("");

        setFormData({
            remarks: "",
            followUpDate: "",
        });

        setErrors({});
    };

    // Close popup
    const closeRemarksPopup = () => {
        setShowModal(false);
        setSelectedRow(null);
        setUpdateStatus("");
        setFormData({
            remarks: "",
            followUpDate: "",
        });
        setErrors({});
    };
    const validate = useCallback(() => {
        const newErrors = {};

        if (!updateStatus) {
            newErrors.status = "Please select status.";
        }
        if (updateStatus === 1 && !formData.followUpDate) {
            newErrors.followUpDate = "Please select follow-up date.";
        }
        if (!formData.remarks.trim()) {
            newErrors.remarks = "Please enter remarks.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }, [updateStatus, formData]);

    // Confirm Cancel
    const handleRemarksOrder = useCallback(async () => {
        if (!selectedRow) return;

        if (!validate()) return;

        setLoadingRow(selectedRow.orderId);

        try {
            const payload = {
                userId: 1,
                orderId: selectedRow.orderId,
                updateStatusId: updateStatus,
                remarks: formData.remarks,
                followUpDate:
                    updateStatus === 1 ? formData.followUpDate : null,
            };

            console.log("Remarks",payload);
            const response=await addFollowUpRemarks(payload);
            if (response?.success) {
                    alert("Remarks addedd successfully! ")
                } else {
                    alert("Remarks not addedd successfully! ")
                }
            closeRemarksPopup();
        } catch (error) {
            setMessage(
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong."
            );
        } finally {
            setLoadingRow(null);
        }
    }, [
        selectedRow,
        updateStatus,
        formData,
        validate,
    ]);

    const columnDefs = useMemo(
        () => [
            {
                headerName: "Action",
                cellRenderer: (params) => (
                    <CButton
                        data={params.data}
                        onClick={openRemarksPopup}
                        loading={loadingRow === params.data.orderId}
                        buttontext="Add Remarks"
                    />
                ),
            },
            { field: "orderId", headerName: "Order ID" },
            { field: "orderType", headerName: "Order Type" },
            { field: "wayBill", headerName: "WayBill" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city" },
            { field: "totalAmount", headerName: "Total Amount" },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },

        ],
        [loadingRow]
    );


    // All Grid Columns
const isReOrder = true;
    return (
        <>
            <CommonMessage text={message} />

            <CFolloUpOrders
                statusId={4}
                columnDefs={columnDefs}
                h4="Follow Up Re Orders"
                reOrder={isReOrder}
            />

            <Modal
                show={showModal}
                onHide={closeRemarksPopup}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Remarks</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        <strong>Order ID :</strong> {selectedRow?.orderId}
                    </p>

                    <div className="mb-3">
                        <CommonDropdown
                            label="Select Status"
                            options={RemarksStatus}
                            value={updateStatus}
                            onChange={(value) => setUpdateStatus(Number(value))}
                            placeholder="Select Status"
                        />

                        {errors.status && (
                            <div className="text-danger mt-1">
                                {errors.status}
                            </div>
                        )}
                    </div>
                    {updateStatus}
                    {Number(updateStatus) === 1 && (
    <div className="mb-3">
        <label className="form-label">
            Follow-up Date & Time
        </label>

        <input
            type="datetime-local"
            name="followUpDate"
            className={`form-control ${
                errors.followUpDate ? "is-invalid" : ""
            }`}
            value={formData.followUpDate}
            onChange={handleChange}
            min={new Date().toISOString().slice(0, 16)}
        />

        {errors.followUpDate && (
            <div className="invalid-feedback">
                {errors.followUpDate}
            </div>
        )}
    </div>
)}
                    {/* <div className="mb-3">
                        <input
                            type="textarea"
                            name="remarks"
                            rows={3}
                            className={`form-control ${
                                errors.remarks ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                        />

                        {errors.remarks && (
                            <div className="invalid-feedback">
                                {errors.remarks}
                            </div>
                        )}
                    </div> */}
                    <div className="mb-3">
                        <textarea
                            name="remarks"
                            rows={3}
                            className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
                            placeholder="Enter Remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                        />

                        {errors.remarks && (
                            <div className="invalid-feedback">
                                {errors.remarks}
                            </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeRemarksPopup}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleRemarksOrder}
                        disabled={loadingRow === selectedRow?.orderId}
                    >
                        {loadingRow === selectedRow?.orderId
                            ? "Saving..."
                            : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default FollowUpReOrders;